import { getPageQoutes } from "../utils/apiService";

export const LIST_PAGE_QUOTES = "quotes/LIST_PAGE_QUOTES";
export const LIST_PAGE_QUOTES_PENDING = "quotes/LIST_PAGE_QUOTES_PENDING";
export const LIST_PAGE_QUOTES_FULFILLED = "quotes/LIST_PAGE_QUOTES_FULFILLED";
export const LIST_PAGE_QUOTES_REJECTED = "quotes/LIST_PAGE_QUOTES_REJECTED";

export const fetchPaginated = page => {
  const payload = getPageQoutes(page);

  return {
    type: LIST_PAGE_QUOTES,
    payload
  };
};



// WEBPACK FOOTER //
// ./src/actions/qoutes.js